import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import * as reducers from './reducers';
import { admin } from './admin';

const isAdminResource = !!window.location.href.match(/\/admin\//);
const combinedReducers = combineReducers(isAdminResource ? {...reducers, router: routerReducer, admin} : {...reducers, router: routerReducer});

export default combinedReducers;


// WEBPACK FOOTER //
// ./src/reducers/index.js